import { queryOptions } from "@tanstack/react-query";
import { api, expectOk } from "../../lib/api";
import { keys } from "../../lib/keys";

/** The /pricing read model; also feeds the gift configurator's presets. */
export const pricingBoardQuery = queryOptions({
  queryKey: keys.pricing,
  queryFn: async () => expectOk(await api.pricing.board({}), 200),
});
